import { connect } from 'react-redux';
import InvestmentUpdates from '../../../components/investor/investments/updates/InvestmentUpdates';

const mapStateToProps = state => ({
  investmentHeader: state.investmentHeader,
  investmentUpdates: state.investmentUpdates,
});

export default connect(mapStateToProps)(InvestmentUpdates);
